module.exports = __webpack_public_path__ + "img/05.3a857c32.png";